<template>
  <div class="rec-video-container">
    <div class="time-control">
      <el-tag type="success" class="cloud-tag">☁ 云端录像（设备离线可用）</el-tag>
      <el-date-picker
        v-model="startTime"
        type="datetime"
        placeholder="选择开始时间"
        format="yyyy年MM月dd日 HH时mm分ss秒"
        value-format="yyyyMMddHHmmss"
        @change="handleTimeChange"
        style="width: 300px"
      ></el-date-picker>
      <span class="time-separator">至</span>
      <el-date-picker
        v-model="endTime"
        type="datetime"
        placeholder="选择结束时间"
        format="yyyy年MM月dd日 HH时mm分ss秒"
        value-format="yyyyMMddHHmmss"
        @change="handleTimeChange"
        style="width: 300px"
      ></el-date-picker>
      <el-button type="primary" @click="changePlayTime" class="change-btn">切换时间</el-button>
    </div>
    <div id="playWind" ref="playWind"></div>
  </div>
</template>

<script>
import EZUIKit from "ezuikit-js";
import { getVideoToken, getVideoTokenFromRemoteServer } from "@/http/api/common";

export default {
  name: "RecVideo",
  data: function () {
    return {
      videoPlayer: null,
      accessToken: "",  // 动态获取，不再硬编码
      deviceInfo: {
        deviceSerial: "BG9380217",
        channelNo: 1
      },
      startTime: "20260104173000",
      endTime: "20260104174000"
    };
  },
  async mounted() {
    await this.fetchAccessToken();
    if (this.accessToken) {
      this.$nextTick(() => {
        this.initVideoPlayer();
      });
    }
  },
  beforeDestroy() {
    this.destroyVideoPlayer();
  },
  methods: {
    // 动态获取萤石云 AccessToken，过期自动刷新
    async fetchAccessToken() {
      try {
        const res = await getVideoToken();
        if (res.code === 200) {
          let token = res.data;
          // 验证 token 是否过期
          try {
            const checkRes = await fetch('https://open.ys7.com/api/lapp/device/list?accessToken=' + token, {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            });
            const data = await checkRes.json();
            if (data.code === '10002') {
              console.warn("Token已过期，正在重新获取...");
              const refreshRes = await getVideoTokenFromRemoteServer();
              if (refreshRes.code === 200) {
                token = refreshRes.data || refreshRes.msg;
                console.log("Token刷新成功:", token);
              } else {
                this.$message.error("视频Token刷新失败，请刷新页面重试");
                return;
              }
            }
          } catch (e) {
            console.error("Token验证请求异常:", e);
          }
          this.accessToken = token;
          console.log("AccessToken就绪:", this.accessToken);
        } else {
          this.$message.error("获取视频Token失败：" + (res.msg || "未知错误"));
        }
      } catch (error) {
        this.$message.error("获取视频Token异常，请检查网络");
        console.error(error);
      }
    },
    initVideoPlayer() {
      const width = document.documentElement.clientWidth;
      const height = document.documentElement.clientHeight;
      
      // 使用云端录像协议 (.cloud.rec)，设备不在线时也可回放萤石云云端存储的录像
      this.videoPlayer = new EZUIKit.EZUIKitPlayer({
        id: 'playWind',
        width: width,
        height: height,
        template: "pcRec",
        url: `ezopen://open.ys7.com/${this.deviceInfo.deviceSerial}/${this.deviceInfo.channelNo}.cloud.rec`,
        accessToken: this.accessToken
      });
      
      this.$nextTick(() => {
        this.changePlayTime();
      });
    },
    destroyVideoPlayer() {
      if (this.videoPlayer) {
        this.videoPlayer.destroy();
        this.videoPlayer = null;
      }
    },
    changePlayTime() {
      if (this.videoPlayer && this.videoPlayer.changePlayUrl) {
        // 使用云端录像URL (.cloud.rec)，即使设备不在线，只要云端有录像即可回放
        const playbackUrl = `ezopen://open.ys7.com/${this.deviceInfo.deviceSerial}/${this.deviceInfo.channelNo}.cloud.rec?begin=${this.startTime}&end=${this.endTime}`;
        this.videoPlayer.changePlayUrl({url: playbackUrl});
        console.log("切换云端回放时间:", playbackUrl);
      }
    },
    handleTimeChange() {
      console.log("时间已更改:", this.startTime, this.endTime);
    }
  }
};
</script>

<style>
.rec-video-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.time-control {
  padding: 15px;
  background-color: #fff;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  flex-wrap: wrap;
}

.cloud-tag {
  font-size: 13px;
  font-weight: bold;
}

.time-separator {
  color: #606266;
  font-size: 14px;
}

.change-btn {
  margin-left: 15px;
}

#playWind {
  flex: 1;
  width: 100%;
}
</style>
